module.exports = __webpack_public_path__ + "static/media/event_crafting.c71fef34.jpg";